'use strict';

import {thirdPartyTracking, initTrackingAgent} from '@edreamsodigeo/frontend-tracking-agent';
import {createStorageClient} from '@edreamsodigeo/frontend-cmp-client';
import {supportareaPageNamesMap} from './tms_datalayer_supportarea_pagenames';
import {bookingAdminPageNamesMap} from './tms_datalayer_bookingadmin';
import {bookingManagementPageNamesMap} from './tms_datalayer_bookingmanagement';
import {membershipPagesMap, membershipPagesPaths} from 'od-modules/models/tms_datalayer_membershipPages';
import {profilePagesMap, profilePagesPaths} from 'od-modules/models/tms_datalayer_profile';
const trackingUtils = require('../utils/tracking.utils');
const uuid = require('uuid');

const isPaymentPageOF2 = Odigeo.AB.isFecoRedirectionToPaymentDesktop || Odigeo.AB.isFecoRedirectionToPaymentMobile;

export default Odigeo.Model.extend({
    dataURL: 'datalayer',
    trackedPages: [],

    pageNamesMap: {
        'cms': 'cms',
        'home': 'homepage',
        'results': 'results',
        'dpresults_flights': 'results',
        'dpresults_accommodation': 'hotel_results',
        'hotel_results': 'results',
        'upsell': 'hotels_upsell',
        'hotel_details': 'room_selection',
        'hotel_guests': 'details_extras',
        'hotel_prime': 'prime',
        'hotel_payment': 'payment',
        'xsellproductselection': 'dp_upsell',
        'dpresults_accommodation_details': 'room_selection',
        'accommodation_details': 'room_selection',
        'flightsummary': 'summary',
        'trip_summary': 'summary',
        'booking': 'summary',
        'fare-rules': 'fare-rules',
        'details': 'details_extras',
        'passengersinfo': 'details_extras',
        'insurance': 'insurances',
        'insurances': 'insurances',
        'travel_insurances': 'insurances',
        'servicepack': 'service_options',
        'canx': 'cancellation_guarantee',
        'cancellation-guarantee': 'cancellation_guarantee',
        'prime': 'prime',
        'flex': 'flexible_dates',
        'flex_dates': 'flexible_dates',
        'flex_page': 'flexible_dates',
        'disruption_compensation': 'disruption-compensation',
        'disruption-compensation': 'disruption-compensation',
        'payment': 'payment',
        'confirmation': 'confirmation',
        'mytrips': 'mytrips',
        'mytripslogin': 'mytripslogin',
        'tripdetails': 'tripdetails',
        'register': 'register',
        'accountblocked': 'accountblocked',
        'flights/frequentpassengers': 'frequent_travelers',
        'accountcreditcards': 'account_credit_cards',
        'accountpreferences': 'account_preferences',
        'resetpassword': 'change_password',
        'primepostbooking': 'primepostbooking',
        'loginexpired': 'loginexpired',
        'additions': 'additions',
        'selection': 'ancillaries',
        'add': 'add',
        'room-selection': 'room_selection',
        'details-extras': 'details_extras',
        'pfhome': 'summary',
        'pfpax': 'details-extras',
        'pfpayment': 'payment',
        'pfconfirmation': 'confirmation',
        'itinerary': 'itinerary',
        'summary': 'summary',
        'faqs': 'faqs',
        'extras_fast_track': 'fast-track',
        '/prime/reactivation/': 'prime-reactivation',
        'flights-bestprices': 'flights-bestprices',
        '/PB/fasttrack/home/': 'fasttrack-home',
        ...profilePagesMap,
        ...membershipPagesMap,
        ...supportareaPageNamesMap,
        ...bookingAdminPageNamesMap,
        ...bookingManagementPageNamesMap,
        // TODO hotel_native_search
    },
    postBookingAccommodationPagesMap: {
        xsellproductselection: 'results',
        pbpayment: 'payment',
    },

    url: function() {
        return this.getUrlByPageName(this.getPageName());
    },

    getUrlByPageName(pageName) {
        return Odigeo.Settings.getProperty('tagManagementUrlFormatter')(this.dataURL + '/' + pageName);
    },

    isHotelsFunnel: function() {
        return Odigeo.Router.getCurrentApp() === 'accommodation';
    },

    isConfirmationPage: function(options) {
        return this.getPageName(options) === 'confirmation';
    },

    isFastTrackPage: function(options) {
        return this.getPageName(options) === 'fasttrack-home';
    },

    getPageName(options) {
        if (Odigeo._.get(options, 'page_name')) {
            return this.pageNamesMap[options.page_name];
        } else {
            let pageName = Odigeo.Utils.isWebmasterPage() ? 'cms' : Odigeo.History.getPageNameFromFragment();
            pageName = pageName === 'ancillaries' ? Odigeo.History.getFragment().match(/(?:[^/]+)(?=$)/)[0] : pageName;
            const isAccommodationPostBooking = this.isAccommodationsPostBooking() && Odigeo._.has(this.postBookingAccommodationPagesMap, pageName);
            const pageNamesMap = isAccommodationPostBooking ? this.postBookingAccommodationPagesMap : this.pageNamesMap;
            return Odigeo._.get(pageNamesMap, pageName || 'home');
        }
    },

    getConvId: function() {
        return `${uuid.v4()}.${new Date().getTime()}`;
    },

    initialize: function() {
        const configParametersTrackingAgent = {
            tagCommander: {
                pageUrl: Odigeo.Settings.getProperty('tagManagementUrlFormatter')('datalayer' + '/'),
            },
            generic: {
                visitID: Odigeo.SessionScope.visitId,
                storageClient: createStorageClient(Odigeo.SessionScope.brand, Odigeo.SessionScope.locale),
                isNativeInterface: Odigeo.SessionScope.isNativeInterface,
                dapiSessionId: Odigeo.SessionScope.dapiSessionId,
                locale: Odigeo.SessionScope.locale,
                flow: Odigeo.SessionScope.flow,
                device: Odigeo.Device.navigator.isIOSWebView ? 'IOS_' : 'ANDROID_',
                brand: Odigeo.SessionScope.brand,
                website: Odigeo.SessionScope.website,
            },
            datamesh: {
                context: '/travel',
            },
        };
        initTrackingAgent(configParametersTrackingAgent);

        this.on('change', this.syncTcVars);
        this.syncTcVars();
    },

    syncTcVars: function() {
        const {getDatalayer, isTMSVariableGlobal} = thirdPartyTracking;
        const prevDatalayer = this.flatten(
            Odigeo.Utils.parseJson(sessionStorage.getItem('tc_vars')) || {} // eslint-disable-line no-restricted-properties
        );
        this.setPreviousPage(prevDatalayer.page_name);
        const funnelChanged = this.funnelChanged(prevDatalayer);
        const syncFn = (key, oldValue, newValue) => newValue || (!funnelChanged || isTMSVariableGlobal(key) ? oldValue : '');
        for (let key in prevDatalayer) {
            if (Object.prototype.hasOwnProperty.call(prevDatalayer, key)) {
                this.set(key, syncFn(key, prevDatalayer[key], this.get(key)));
            }
        }
        this.addClientSideAttributes();
        window.tc_vars = {
            ...this.flatten(this.toJSON()),
            ...getDatalayer(),
        };
        sessionStorage.setItem('tc_vars', JSON.stringify(window.tc_vars)); // eslint-disable-line no-restricted-properties
    },

    setPreviousPage: function(pageName = '') {
        const prevPage = this.get('page_name');
        if (prevPage !== pageName) {
            this.set('page_previous', pageName);
        }
    },

    funnelChanged: function(prevDatalayer) {
        const inSearchID = this.get('in_searchID');
        return (
            !!this.get('env_brand') && // prevent empty datalayer
            (prevDatalayer.product !== this.get('product') ||
                inSearchID && inSearchID !== '0' && (prevDatalayer.in_searchID !== inSearchID) ||
                prevDatalayer.hotels_search_id !== this.get('hotels_search_id'))
        );
    },

    parse: function(data) {
        return this.flatten(data);
    },

    hashValue: function(value) {
        const utf8 = new TextEncoder().encode(value);
        return crypto && crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            return hashArray
                .map((bytes) => bytes.toString(16).padStart(2, '0'))
                .join('');
        });
    },

    fireEvent: function(category, key, value) {
        const {shouldSkipTracking} = thirdPartyTracking;
        this.set(key, value);
        if (key === 'customer_email') {
            this.hashValue(value).then((hash) => this.set('customer_email_hash', hash));
        }
        this.syncTcVars();
        const data = {[key]: value, event_category: category};
        if (!shouldSkipTracking()) {
            Odigeo._.method('tC.container.reload', {events: {click: [{}, data]}})(window);
        }
    },

    loadContainer: function() {
        const {shouldSkipTracking} = thirdPartyTracking;
        const pageName = this.get('page_name');
        if (shouldSkipTracking() || pageName && this.trackedPages[this.trackedPages.length - 1] === pageName) {
            return;
        }
        this.syncTcVars();
        trackingUtils.counterMetric('TMS_CONTAINER_RELOAD', {'<PAGE_NAME>': pageName});
        Odigeo._.method('tC.container.reload', {events: {page: [{}, {}]}})(window);
        this.trackedPages.push(pageName);
    },

    isPageInWhitelist(options) {
        return Odigeo._.has(Odigeo._.invert(this.pageNamesMap), this.getPageName(options));
    },

    fetchDatalayer: function() {
        if (this.isPageInWhitelist()) {
            this.fetch({
                data: {product: this.getProduct()},
                success: this.loadContainer.bind(this),
                error: this.handleErrorOnBuildDatalayer.bind(this),
            });
        }
    },

    updateDatalayer: function(data) {
        if (this.isConfirmationPage(data)) {
            this.set({g_conv_id: this.getConvId()});
        }
        if (!Odigeo._.isEmpty(data)) {
            this.set(this.flatten(data));
            this.loadContainer();
        } else {
            this.fetchDatalayer();
        }
    },

    skipFetchDatalayerOnConfirm: function(options) {
        const product = this.getProduct(options);
        const isFlightsProduct = product === 'flights';
        const isSeatPB = product === 'seat_post_booking';
        return (isPaymentPageOF2 && isFlightsProduct) || this.isHotelsFunnel() || isSeatPB;
    },
    isManageBookingPage: function(options, pageNamesMap) {
        const pageList = Object.keys(pageNamesMap);
        return pageList.filter((page) => {
            if (options !== undefined && options.page_name !== undefined)
                return options.page_name.includes(page);
        }).length > 0;
    },
    updateAndExtendDatalayer(extendedData, options) {
        const isConfirmPage = this.isConfirmationPage(options);
        const isOldManageBookingPage = this.isManageBookingPage(options, bookingManagementPageNamesMap);
        const isBookingAdminPage = this.isManageBookingPage(options, bookingAdminPageNamesMap);
        if (isConfirmPage) {
            extendedData = {
                ...extendedData,
                g_conv_id: this.getConvId(),
            };
        }
        if (isConfirmPage && this.skipFetchDatalayerOnConfirm(options)) {
            const confirmationTemplate = {
                flights: 'confirmation',
                accommodation: 'hotel-bf-confirmation',
                seat_post_booking: 'seat-PB',
            };
            const confirmationDataLayer = {
                ...extendedData,
                page_name: options.page_name,
                env_template: confirmationTemplate[this.getProduct(options)],
            };
            this.extendDataLayer(confirmationDataLayer);
        } else if (isOldManageBookingPage || isBookingAdminPage) {
            const mmbDataLayer = {
                ...extendedData,
                page_name: options.page_name,
                env_template: 'mybooking',
            };
            this.extendDataLayer(mmbDataLayer);
        } else {
            if (this.isPageInWhitelist(options)) {
                const fetchOptions = {
                    data: {product: this.getProduct(options)},
                    success: () => {
                        this.extendDataLayer(extendedData);
                    },
                    error: this.handleErrorOnBuildDatalayer.bind(this),
                };
                if (Odigeo._.get(options, 'page_name')) {
                    let pageName;

                    if (this.isMembershipPages(options)) {
                        pageName = this.getMembershipPagesMapKeyByValue(options.page_name);
                    } else if (this.isProfilePages(options)) {
                        pageName = this.getProfilePagesMapKeyByValue(options.page_name);
                    } else {
                        pageName = this.getPageName(options);
                    }

                    fetchOptions.url = this.getUrlByPageName(pageName);
                }
                this.fetch(fetchOptions);
            }
        }
    },

    extendDataLayer(extendedData) {
        this.set(this.flatten(extendedData));
        this.loadContainer();
    },

    handleErrorOnBuildDatalayer: function() {
        this.set('page_name', this.getPageName());
        this.loadContainer();
    },

    addClientSideAttributes: function() {
        const ofVersion = Odigeo.SessionScope.oneFrontVersion || '';
        this.set({
            ext_ga_client_id: trackingUtils.getClientId(),
            page_url: document.location.href,
            of_version: ofVersion,
        });
    },

    sendTmsEvent(eventCategory) {
        thirdPartyTracking.fireDataLayerEvent({
            event_category: eventCategory,
        });
    },

    isAccommodationsPostBooking: function() {
        return Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'));
    },

    getProduct(options) {
        if (Odigeo._.get(options, 'product')) {
            return options.product;
        } else if (this.isHotelsFunnel()) {
            return 'accommodation';
        } else if (this.isAccommodationsPostBooking()) {
            return 'hotel_post_booking';
        } else if (this.isMembershipPages(options)) {
            return 'membership-pages';
        } else if (this.isFastTrackPage(options)) {
            return 'fasttrack_post_booking';
        } else if (this.isProfilePages(options)) {
            return 'flights'; // TODO: change to 'profile-pages' when rolling out user area page
        }
        return Odigeo.Utils.getFunnelInGlobalScope();
    },

    flatten: function(obj, name) {
        var out = {};

        if (Odigeo._.isNull(obj) || Odigeo._.isUndefined(obj) || Odigeo._.isNaN(obj)) {
            out[name] = '';
            return out;
        }

        if (!Odigeo._.isObject(obj.valueOf())) {
            out[name] = obj.toString();
            return out;
        }

        for (var p in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, p)) {
                var prop = this.flatten(obj[p], p);
                out = Odigeo._.merge(out, prop);
            }
        }

        return out;
    },

    isMembershipPages(options) {
        if (options && options.page_name) {
            return Object.values(membershipPagesPaths)
                .some((path) => options.page_name.includes(path));
        }
        return false;
    },

    isProfilePages(options) {
        if (options && options.page_name) {
            return Object.values(profilePagesPaths)
                .some((path) => options.page_name.includes(path));
        }
    },

    getMembershipPagesMapKeyByValue(pageName) {
        const page = membershipPagesMap[pageName];
        return page === null ? pageName : page;
    },

    getProfilePagesMapKeyByValue(pageName) {
        const page = profilePagesMap[pageName];
        return page === null ? pageName : page;
    },
});
